import React from 'react';

interface IPageProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  image?: string;
  keywords?: string[];
}

function Page({ title, children, description, image, keywords }: IPageProps) {
  return (
    <>
      <title>{title}</title>
      {keywords && <meta name="keywords" content={keywords.join(', ')} />}
      {description && <meta property="description" content={description} />}

      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={location.href} />
      {image && <meta property="og:image" content={image} />}
      {description && <meta property="og:description" content={description} />}
      <meta data-key="site" property="og:site_name" content="Походники Пензы" />

      {children}
    </>
  );
}

export default Page;
